import { SizeRecommendTooltip } from '../components/SizeRecommendTooltip';
import { Props, useSizeRecommendTooltipService } from '../services/useSizeRecommendTooltipService';

export const SizeRecommendTooltipContainer: React.FC<React.PropsWithChildren<Props>> = (props) => {
  const { extraBottom, isTooltipShown, goToSizeRecommend } = useSizeRecommendTooltipService(props);

  if (!isTooltipShown) {
    return null;
  }
  return <SizeRecommendTooltip extraBottom={extraBottom} goToSizeRecommend={goToSizeRecommend} />;
};
